module.exports = __webpack_public_path__ + "img/图片3.3d13d566.png";